<div *ngIf="!accept_creation">

  <section class="error-area">
    <div class="error-item">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="error-text">
                    <h3>Alert</h3>
                    <p>Your Profile already has a registered service!!!</p>
                    <span>Please sign out to register a new service</span>
                    <button (click)="confirmSignOut()">Sign Out</button>
                </div>
            </div>
        </div>
    </div>
  </section>

</div>


<div *ngIf="accept_creation">

  <div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Managed Service Profile</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li><a routerLink="/register_as">Register As</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Managed Service</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
  </div>

  <div class="dashboard-area pt-100">
    <div class="container">
        <div class="create-information">
            <form [formGroup]="mform" (ngSubmit)="saveData()">
                <h3>{{title_main}}</h3>

                <div class="row">

                    <div class="row">
                      <!-- Service Category -->
                      <div class="col-lg-6">
                        <div class="form-group">
                            <label for="serviceCategoryId">Service Category</label>
                            <ng-select
                            formControlName="serviceCategoryId"
                            [ngClass]="{'is-invalid': displayMessage.serviceCategoryId}"
                            [items]="categories"
                            bindLabel="name"
                            bindValue="id">
                            </ng-select>
                            <span class="invalid-feedback">
                              {{displayMessage.serviceCategoryId}}
                            </span>
                        </div>
                      </div>

                      <!-- Service Name -->
                      <div class="col-lg-6">
                        <div class="form-group">
                            <label for="name">Service/Business Name</label>
                            <input type="text" class="form-control"
                            id="name" placeholder="or name of a person offering service"
                            formControlName="name"
                            [ngClass]="{'is-invalid': displayMessage.name }">
                            <span class="invalid-feedback">
                              {{displayMessage.name}}
                            </span>
                        </div>
                      </div>

                    </div>

                    <div class="row">
                      <!-- Address Line -->
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label for="line">Address:</label>
                            <input type="text" class="form-control"
                            id="line" placeholder="Service/Business address"
                            formControlName="line"
                            [ngClass]="{'is-invalid': displayMessage.line }">
                            <span class="invalid-feedback">
                              {{displayMessage.line}}
                            </span>
                        </div>
                      </div>

                      <!-- Country -->
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label for="city">Country:</label>
                          <ng-select
                              formControlName="country"
                              [ngClass]="{'is-invalid': displayMessage.country}"
                              [items]="countries"
                              bindLabel="name"
                              bindValue="shortName">
                              </ng-select>
                              <span class="invalid-feedback">
                                {{displayMessage.city}}
                              </span>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="country.value != null" class="row">
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label for="city">State:</label>
                          <ng-select
                              formControlName="state"
                              [ngClass]="{'is-invalid': displayMessage.state}"
                              [items]="states"
                              bindLabel="state"
                              bindValue="state">
                              </ng-select>
                              <span class="invalid-feedback">
                                {{displayMessage.city}}
                              </span>
                        </div>
                      </div>

                      <div *ngIf="state.value != null" class="col-lg-6">
                        <div class="form-group">
                          <label for="city">City:</label>
                          <ng-select
                              formControlName="city"
                              [ngClass]="{'is-invalid': displayMessage.city}"
                              [items]="cities"
                              bindLabel="city"
                              bindValue="city">
                              </ng-select>
                              <span class="invalid-feedback">
                                {{displayMessage.city}}
                              </span>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                        <!-- Description -->
                        <div class="col-lg-6">
                          <div class="form-group">
                              <label>Description</label>
                              <textarea id="your_message" class="form-control" rows="8"
                                formControlName="description"
                              placeholder="Decscribe the nature of your business/service or keywords associated with your business/service"></textarea>
                          </div>
                        </div>

                        <!-- Contact Number -->
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="contactNumber">Service/Business Primary Contact</label>
                                <input type="text" class="form-control"
                                id="contactNumber" placeholder="08147526931"
                                formControlName="contactNumber"
                                [ngClass]="{'is-invalid': displayMessage.contactNumber }">
                                <span class="invalid-feedback">
                                  {{displayMessage.contactNumber}}
                                </span>
                            </div>
                        </div>
                    </div>

                </div>

                <hr>

                <h3>{{title_sub}}</h3>

                <div class="row">

                  <div class="row">
                    <!-- First Name -->
                    <div class="col-lg-6">
                    <div class="form-group">
                        <label for="firstname">Firstname</label>
                        <input type="text" class="form-control"
                        id="firstname" placeholder="firstname"
                        formControlName="firstname"
                        [ngClass]="{'is-invalid': displayMessage.firstname }">
                        <span class="invalid-feedback">
                          {{displayMessage.firstname}}
                        </span>
                    </div>
                  </div>

                  <!-- Lastname -->
                  <div class="col-lg-6">
                    <div class="form-group">
                        <label for="lastname">Lastname</label>
                        <input type="text" class="form-control"
                        id="lastname" placeholder="lastname"
                        formControlName="lastname"
                        [ngClass]="{'is-invalid': displayMessage.lastname }">
                        <span class="invalid-feedback">
                          {{displayMessage.lastname}}
                        </span>
                    </div>
                  </div>

                  </div>

                  <div class="row">
                  <!-- Contact -->
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label for="contact">Contact:</label>
                        <input type="text" class="form-control"
                          id="contact" placeholder="08024714586"
                          formControlName="contact"
                          [ngClass]="{'is-invalid': displayMessage.contact }">
                          <span class="invalid-feedback">
                            {{displayMessage.contact}}
                          </span>
                      </div>
                    </div>

                  <!-- email -->
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label for="email">Email:</label>
                          <input type="email" class="form-control"
                          id="email" placeholder="example@yahoo.com"
                          formControlName="email"
                          [ngClass]="{'is-invalid': displayMessage.email }">
                          <span class="invalid-feedback">
                            {{displayMessage.email}}
                          </span>
                      </div>
                    </div>
                </div>

                  <div class="row">
                    <!-- Address-->
                    <div class="col-lg-12">
                    <div class="form-group">
                      <label for="address">Address:</label>
                        <textarea type="text" class="form-control" rows="5"
                        id="address" placeholder="Residential/Business address"
                        formControlName="address"
                        [ngClass]="{'is-invalid': displayMessage.address }">
                        </textarea>
                        <span class="invalid-feedback">
                          {{displayMessage.address}}
                        </span>
                    </div>
                  </div>

                  </div>

                <div class="row">
                    <!-- Username -->
                    <div class="col-lg-6">
                      <div class="form-group">
                          <label for="username">Username:</label>
                          <input type="text" class="form-control"
                          id="username" placeholder="username"
                          formControlName="username"
                          [ngClass]="{'is-invalid': displayMessage.username }">
                          <span class="invalid-feedback">
                            {{displayMessage.username}}
                          </span>
                      </div>
                    </div>

                    <!-- Password -->
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label for="password">Password:</label>
                          <input type="password" class="form-control"
                          id="password"
                          formControlName="password"
                          [ngClass]="{'is-invalid': displayMessage.password }">
                          <span class="invalid-feedback">
                            {{displayMessage.password}}
                          </span>
                      </div>
                    </div>

                    <!-- <div class="col-lg-4">
                      <div class="form-group">
                        <label for="confirmPassword">Password:</label>
                          <input type="password" class="form-control"
                          id="confirmPassword"
                          formControlName="confirmPassword"
                          [ngClass]="{'is-invalid': displayMessage.confirmPassword }">
                          <span class="invalid-feedback">
                            {{displayMessage.confirmPassword}}
                          </span>
                          <span *ngIf="confirmPassword.errors?.['confirmedValidator']">
                            Passwords did not match
                          </span>
                      </div>
                    </div> -->
                </div>

                </div>


                <div class="text-left">
                  <button type="submit" class="btn create-ac-btn"
                    [title]="mform.valid"
                    [disabled]="!mform.valid">
                    Save</button>
                </div>

            </form>
        </div>

    </div>
  </div>

</div>
